<div class="component-faq-standalone" *ngIf="data">
  <div class="component-faq-standalone__top">
    <img src="../../assets/images/logo.svg" alt="">
    <h3>How can we help you?</h3>
    <input type="text" placeholder="Search through FAQs..." [(ngModel)]="searchValue" (input)="handleInputChange()"/>
  </div>
  <div class="component-faq-standalone__buttons">
    <button class="helper-generic-button" (click)="expandAll()">
      <span *ngIf="!areAllOpen">Expand All</span>
      <span *ngIf="areAllOpen">Collapse All</span>
    </button>
  </div>
  <div class="component-faq-standalone__single"
       *ngFor="let single of data | searchSimple:searchValue; let index = index;"
       [class.active]="single.isOpen">
    <div class="component-faq-standalone__single-title" [class.active]="single.isOpen"
         (click)="activeFaqView(single)">{{single.title}}</div>
    <div class="component-faq-standalone__single-content"
         [innerHTML]="sanitizer.bypassSecurityTrustHtml(single.content | texthighlight:searchValue)"></div>
  </div>
</div>

<app-loader *ngIf="!data"></app-loader>
